import SportsPrecheckoutBlock from './SportsPrecheckoutBlock';
import { SportsPrecheckoutBlockProps, SportsPrecheckoutBlockValueProps } from './types';

export type { SportsPrecheckoutBlockProps, SportsPrecheckoutBlockValueProps };
export default SportsPrecheckoutBlock;
